export const PLATFORM = {
  name: "UGC & CO",
  tagline: "Les outils et la communauté des créatrices UGC",
  domain: "ugcetco.com",
  logoIcon: "/brand/ugcco-icon.png",
  logoWordmark: "/brand/ugcco-wordmark.png",
  logoFull: "/brand/ugcco-full.png",
};

export const NAV = [
  { to: "/applications", label: "Applications" },
  { to: "/boite-a-outils", label: "Boîte à outils" },
  { to: "/le-cercle", label: "Le Cercle" },
  { to: "/academie", label: "Académie" },
];

// Espaces de la plateforme encore en préparation : affichés « Bientôt disponible », sans fonctionnalité simulée.
export const SPACES = {
  "boite-a-outils": {
    eyebrow: "Boîte à outils",
    title: "Des ressources prêtes à l'emploi pour créer plus sereinement.",
    intro: "La boutique UGC & CO réunira des guides, des PDF, des scripts, des prompts, des modèles et des checklists, pensés pour les créatrices débutantes.",
    planned: [
      { t: "Guides", d: "Des méthodes pas à pas sur les sujets clés de l'UGC." },
      { t: "Scripts", d: "Des trames de scripts à adapter à tes produits." },
      { t: "Prompts", d: "Des formulations pour t'aider à trouver des idées." },
      { t: "Modèles", d: "Des documents prêts à remplir pour t'organiser." },
      { t: "Checklists", d: "Des listes de vérification avant, pendant et après le tournage." },
    ],
    note: "En attendant, le parcours UGC GO inclut déjà une bibliothèque de ressources : 10 idées de vidéos, 10 accroches, une checklist de tournage et un mini-glossaire.",
  },
  "le-cercle": {
    eyebrow: "Le Cercle UGC & CO",
    title: "Un espace pour avancer ensemble, entre créatrices.",
    intro: "Le Cercle sera l'espace communautaire de UGC & CO : un lieu bienveillant pour échanger, partager ses progrès et se motiver entre créatrices UGC.",
    planned: [
      { t: "Partage d'expériences", d: "Échanger sur ses premières vidéos et ce que l'on apprend." },
      { t: "Entraide", d: "Poser ses questions et s'encourager mutuellement." },
      { t: "Rendez-vous", d: "Des moments dédiés pour progresser ensemble." },
    ],
    note: "Le Cercle est en préparation. Aucun espace d'échange n'est encore ouvert.",
  },
  academie: {
    eyebrow: "Académie",
    title: "Des formations et des tutoriels pour aller plus loin.",
    intro: "L'Académie UGC & CO proposera des formations et des tutoriels pour développer tes compétences de créatrice, à ton rythme.",
    planned: [
      { t: "Formations", d: "Des programmes structurés sur un sujet précis." },
      { t: "Tutoriels", d: "Des vidéos courtes pour maîtriser un geste ou un outil." },
    ],
    note: "Aucune formation n'est encore publiée.",
  },
};

export const WAITLIST_TOPICS = [
  { id: "boite-a-outils", label: "Boîte à outils" },
  { id: "academie", label: "Académie" },
];
